import { Button, Col, FormGroup, InputGroup, Row } from "react-bootstrap";
import FormLayout from "../../../components/Layout/FormLayout";
import InputLable from "../../../components/Inputs/InputLable";
import DatePicker from "react-datepicker";
import { useState } from "react";
import ReactDatePicker from "../../../components/Inputs/ReactDatePicker";
import { useFormikContext } from "formik";
import ReactInput from "../../../components/Inputs/ReactInput";
import toast from "react-hot-toast";
import request from "../../../utils/request";
import { UserContext } from "../../../Context/UserContextAPI";
import { useContext } from "react";
const AddSubscriptionPayment = ({
	subscriptionPayment,
	dueMonths = [],
	totalMoney = 0,
}) => {
	const { currentUser } = useContext(UserContext);

	// current month with 1 date
	const currentMonth = new Date();
	currentMonth.setDate(1);

	const initialValue = {
		paymentDate: dueMonths,
		amount: totalMoney * dueMonths.length,
		remarks: "",
		user_id: currentUser.id,
		initialFee: totalMoney,
	};

	const apiHandler = async (data) => {
		if (data.paymentDate.length < 1) {
			toast.error("Please select at least one month");
			return null;
		}
		try {
			const response = await request.create(
				"subscriptionPayment/payment/bkash/create",
				{
					amount: data.amount,
					paymentDate: data.paymentDate,
					remarks: data.remarks,
					user_id: currentUser.id,
				},
			);
			console.log(response);
			if (response.status === "OK") {
				window.location.href = response.data.bkashURL;
			}
		} catch (error) {
			toast.error(error.message);
		}
	};

	return (
		<div>
			<FormLayout initialValues={initialValue} apiHandler={apiHandler} noButton>
				<SubscriptionPaymentForm subscriptionPayment={subscriptionPayment} />
			</FormLayout>
		</div>
	);
};

export default AddSubscriptionPayment;

const SubscriptionPaymentForm = ({ subscriptionPayment }) => {
	const { values, setFieldValue } = useFormikContext();
	return (
		<div>
			<Row>
				<Col sm={4}>
					<InputLable title={"Select Month(multiple)"} />
				</Col>
				<Col sm={8}>
					<div className="customDatePickerWidth" style={{ zIndex: 1000 }}>
						<DatePicker
							selectedDates={values.paymentDate}
							selectsMultiple
							showMonthYearPicker
							show
							onChange={(dates) => {
								setFieldValue("paymentDate", dates);
								setFieldValue("amount", dates.length * values.initialFee);
							}}
							shouldCloseOnSelect={false}
							disabledKeyboardNavigation
							className="form-control"
							dateFormat={"MMM yyyy"}
							// excludeDates={subscriptionPayment?.map(
							// 	(item) => new Date(item.payment_date),
							// )}
						/>
					</div>
				</Col>
			</Row>
			<Row className="mt-3">
				<Col sm={4}>
					<InputLable title={"Amount"} />
				</Col>
				<Col sm={8}>
					<ReactInput
						name="amount"
						type="number"
						readOnly
						GroupComponent={<Button size="sm">৳</Button>}
					/>
				</Col>
			</Row>
			<Row className="mt-3">
				<Col sm={4}>
					<InputLable title={"Remarks"} />
				</Col>
				<Col sm={8}>
					<ReactInput name="remarks" type="text" as="textarea" rows={3} />
				</Col>
			</Row>

			<Row className="mt-3">
				<Col sm={12} className="d-flex justify-content-end">
					<Button type="submit" variant="primary">
						Submit
					</Button>
				</Col>
			</Row>
		</div>
	);
};
